import { createApp } from "vue";

import "Resources/util/console";
import "../css/app.css"
import "../css/style.css"
import "./plugins/toastr";
import "./plugins/axios";
import "./vendor";
import "../sass/main.scss";


// import Vuex from 'vuex';
// createApp(Vuex);
// import { currentInstance } from './currentInstance.js';

import * as consoleUtil from 'Resources/util/console';


// import Swal from 'sweetalert2/dist/sweetalert2';

import store from "./store";
// import { EventBus } from "./event-bus.js";
import mitt from "mitt";
import { router } from "./plugins/vue-router";
import { i18n } from "./plugins/i18n";
import Pagination from "./components/Form/Pagination.vue";


// components
import Master from "./layouts/Master.vue";
import MainLayout from "./layouts/MainLayout.vue";

const app = createApp(Master);

const emitter = mitt();
app.config.globalProperties.emitter = emitter;
app.provide("emitter", emitter);
app.use(router);
app.use(i18n);
app.use(store);

store.dispatch("auth/boot_hash");

// app.use(EventBus);

app.component("m-layout", MainLayout);
app.component("pagination", Pagination);

import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';

app.component("scale-loader", ScaleLoader);

import MoonLoader from 'vue-spinner/src/MoonLoader.vue';

app.component("moon-loader", MoonLoader);

import TagsInput from "Resources/components/Form/TagsInput.vue";
app.component("tags-input", TagsInput);

import Multiselect from "vue-multiselect";
app.component("multiselect", Multiselect);
import "vue-multiselect/dist/vue-multiselect.css";

import FooTable from "Resources/components/FooTable.vue";
app.component("foo-table", FooTable);

import VTooltipPlugin from "v-tooltip";
app.use(VTooltipPlugin);
app.directive("tooltip", VTooltipPlugin.VTooltip);
app.component("v-tooltip", VTooltipPlugin.VTooltip);
// import "v-tooltip/dist/v-tooltip.css";

import Card from "Resources/components/UI/Card/Card.vue";
app.component("card", Card);
import CardHeader from "Resources/components/UI/Card/CardHeader.vue";
app.component("card-header", CardHeader);

import MSmallButtton from "Resources/components/UI/SmallButton.vue";
app.component("m-small-button", MSmallButtton);

import Switcher from '@/components/Form/Switcher.vue';
app.component("switcher", Switcher);

// import FooTable from "Resources/components/FooTable.vue";
// app.component("foo-table", FooTable);

import Search from "Resources/components/Form/Search.vue";
app.component("m-search", Search);

// import Nrc from "Resources/components/Nrc.vue";
// app.component("nrc", Nrc);

// import ClipLoader from "vue-spinner/src/ClipLoader";
// app.component("clip-loader", ClipLoader);

// import TicketTemplate from "Resources/components/TicketTemplate.vue";
// app.component("ticket-template", TicketTemplate);

// import ProgressBar from "Resources/components/ProgressBar.vue";
// app.component("progress-bar", ProgressBar);

// import ReportBox from "./components/ReportBox.vue";
// app.component("report-box", ReportBox);

/**
 * Core Component
 */
import Input from "Core/components/Form/Input.vue";
import './bootstrap';
import '../css/app.css'; 
import './components.vue'; // Adjust this path if necessary
import './plugins/toastr';  // Assuming toastr is set up in a plugin file
import './plugins/axios';    // Assuming axios is set up in a plugin file
app.component("m-input", Input);

// import Textarea from "Core/components/Form/Textarea.vue";
// app.component("m-textarea", Textarea);

import CheckBox from "Core/components/Form/CheckBox.vue";
app.component("tw-checkbox", CheckBox);

import VDatePicker from "Resources/components/Form/VueDatePicker.vue";
app.component("v-date-picker", VDatePicker);

// import ImageUpload from "Resources/components/Form/SingleUploader.vue";
// app.component("image-upload", ImageUpload);

// // require("./components");
import.meta.glob([
    '../images/**',
    '../fonts/**',
  ]);

app.mount("#app");


store.dispatch("cache/fresh_location_list");
store.dispatch("auth/fresh_account");

export default app;
